<template>
  <wizzard-container full-width>
    <v-alert
      v-if="$v.form.tags.$error"
      border="left"
      colored-border
      type="error"
      class="box-sha"
    >
      {{ $t('You must select at lest one tag') }}
    </v-alert>
    <div
      v-for="(group, index) in groupedTagFields"
      :key="group.key"
    >
      <div
        class="title font-weight-medium"
        :class="{ 'mt-12': index > 0 }"
      >
        {{ group.label }}
      </div>
      <v-row>
        <v-col
          v-for="field in group.fields"
          :key="field.key"
          cols="12"
          sm="6"
          md="4"
          lg="3"
        >
          <v-checkbox
            v-model="form.tags[field.key]"
            :label="field.label[$i18n.locale] || field.label.en || field.key"
            hide-details
          />
        </v-col>
      </v-row>
    </div>
    <form-action-buttons
      status="listed"
      @submit="submit"
    />
  </wizzard-container>
</template>

<script>
import axios from 'axios';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import FormValidationMixin from '@/lib/FormValidationMixin';
import FormActionButtons from '@/views/ads/forms/FormActionButtons.vue';
import WizzardContainer from '@/views/ads/forms/WizzardContainer.vue';

export default {
  mixins: [validationMixin, FormValidationMixin],
  components: {
    FormActionButtons,
    WizzardContainer,
  },
  props: {
    businessId: { type: String, required: true },
    business: { type: Object, default: null },
    tagFields: { type: Array, required: true },
  },
  validations() {
    return {
      form: {
        tags: {
          required,
          hasAtLeastOneSelectedAmenity: this.hasAtLeastOneSelectedAmenity,
        },
      },
    };
  },
  data() {
    return {
      form: {
        tags: {},
      },
    };
  },
  watch: {
    business: {
      immediate: true,
      handler() {
        this.setFormData();
      },
    },
    tagFields: {
      immediate: true,
      handler() {
        this.setFormData();
      },
    },
  },
  computed: {
    groupedTagFields() {
      const groups = this.tagFields.reduce((acc, field) => {
        const groupKey = field.group && field.group.en ? field.group.en : 'Other';
        if (!acc[groupKey]) {
          acc[groupKey] = {
            key: groupKey,
            label: field.group && field.group[this.$i18n.locale]
              ? field.group[this.$i18n.locale]
              : ((field.group && field.group.en) || 'Other'),
            fields: [],
          };
        }
        acc[groupKey].fields.push(field);
        return acc;
      }, {});

      return Object.values(groups);
    },
  },
  methods: {
    hasAtLeastOneSelectedAmenity(value) {
      return Object.values(value || {}).some((selected) => selected === true);
    },
    setFormData() {
      if (!this.business) {
        return;
      }

      const sourceTags = this.business.tags && typeof this.business.tags === 'object'
        ? this.business.tags
        : {};

      this.form.tags = this.tagFields.reduce((acc, field) => {
        acc[field.key] = Boolean(sourceTags[field.key]);
        return acc;
      }, {});
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.scrollToFirstError();
        return;
      }
      this.$store.dispatch('loading', true);
      axios
        .post(`panel/ads/validation/business/amenities/${this.businessId}`, this.form)
        .then(() => {
          this.$store.dispatch('clearErrors');
          this.$store.dispatch('message', this.$t('Saved successfully'));
          this.$emit('success');
        })
        .catch((error) => {
          const errors = error.response && error.response.data && error.response.data.errors
            ? error.response.data.errors
            : {};
          this.$store.dispatch('setErrors', errors);
          this.scrollToFirstError();
        })
        .finally(() => {
          this.$store.dispatch('loading', false);
        });
    },
  },
};
</script>
